export default __webpack_public_path__ + "static/media/barreto_712mth.3cba8dce.jpg";